<template>
  <li class="no-bullets">
    <div class="d-flex align-items-center" @dragenter="onDragEnter(node)">
      <!--make this top few things ( expand, prefix, etc? ) slots and overridable -->
      <span v-if="showCollapse && node.isContainer" @click.stop="toggleNode(node)">
        <i :class="node.expanded ? 'fas fa-caret-down caret-icon pe-1' : 'fas fa-caret-right caret-icon pe-1'"></i>
      </span>
      <span @click.stop="$emit('node-clicked', node)" class="d-flex align-items-center flex-grow-1">
        <span v-if="showPrefixIcon && node.isContainer" class="icon-stack">
          <i class="fas fa-folder icon-stack-3x icon-folder"></i>
          <i v-show="showLockCondition ? showLockCondition(node) : null" class="fas fa-lock icon-stack-2x"></i>
        </span>
        <span v-if="showPrefixIcon  && !node.isContainer">
          <i class="bi bi-file-earmark-text"></i>
        </span>
        <span class="node-text" @click="$emit('item-selected', node)" :class="{'item-selected': node.isSelected }">{{ node[containerTextField] !== undefined ? node[containerTextField]  : node[nodeTextField] }}</span>
      </span>
      <span class="trash" @click.stop="removeItem(node)">
        <BIconTrash icon="trash" style="pointer-events: none;"></BIconTrash>
      </span>
    </div>
      <ul v-if="(node.expanded && node.isContainer && (showLockCondition ? !showLockCondition(node) : true))" class="tree-children">
        <draggable
            :list="node[childArrayName] || (node[childArrayName] = [])"
            :group="{ name: group, pull: pullOption, put: putOption }"
            :move="onDragMove"
            :clone="clone"
            item-key="_tempKey"
        >
          <template #item="{ element: child }">
            <draggable-tree-node
                :node="child"
                :parent-node="node"
                :node-text-field="nodeTextField"
                :node-id-field="nodeIdField"
                :container-text-field="containerTextField"
                :container-id-field="containerIdField"
                :child-array-name="childArrayName"
                :show-prefix-icon="showPrefixIcon"
                :show-collapse="showCollapse"
                :show-lock-condition="showLockCondition"
                :enable-node-drag-to-root="enableNodeDragToRoot"
                :pull-option="pullOption"
                :put-option="putOption"
                :enable-only-drag-containers="enableOnlyDragContainers"
                :group="group"
                @item-selected="(node) => $emit('item-selected', node)"
                />
          </template>
        </draggable>
      </ul>
  </li>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "DraggableTreeNode",
  components: { draggable },
  props: {
    node: Object,
    parentNode: Object,
    group: String,
    showPrefixIcon: Boolean,
    showCollapse: Boolean,
    containerIdField: String,
    clone: Function,
    pullOption: [Boolean, String, Function],
    putOption: [Boolean, Array, Function],
    showLockCondition: [Function, null],
    nodeTextField: {
      type: String,
      default: "text"
    },
    containerTextField: {
      type: String,
      default: "text"
    },
    nodeIdField: {
      type: String,
      default: "id"
    },
    childArrayName: {
      type: String,
      default: "children"
    },
    enableNodeDragToRoot: {
        type: Boolean,
        default: false
    },
    enableOnlyDragContainers: {
        type: Boolean,
        default: false
    }
  },
  methods: {
    toggleNode(node) {
      if((this.showLockCondition ? this.showLockCondition(node) : false))
      {
          return;
      }
       
      node.expanded = !node.expanded;
    },
    onDragEnter(node)
    {
      if(!node.expanded)
      {
        this.toggleNode(node);
      }
    },
    onDragMove(evt) {
      if(this.enableOnlyDragContainers)
      {
         return evt.draggedContext.element.isContainer; 
      }

      if(!this.enableNodeDragToRoot)
      {
          let currentNode = evt.related;

          // Get the level by counting the number of parent elements (ul) up the chain
          let level = 0;

          // Traverse up the DOM tree to count levels
          while (currentNode && !currentNode.classList?.contains('tree-container')) {
              if (currentNode.tagName === 'UL') {
                  level++;
              }
              currentNode = currentNode.parentNode;
          }

          const hasNoItems = !evt.draggedContext.element[this.childArrayName] || evt.draggedContext.element[this.childArrayName].length < 1;
          // Prevent moving to root if it's a file/folder without children
          if (hasNoItems && level === 1) {
              return false; // Block the drop
          }
      }
      
      return true; // Allow the drop
    },
    removeItem(node) {
        if(this.parentNode && this.parentNode[this.childArrayName])
        {
          const itemIndex = this.parentNode[this.childArrayName].findIndex(i => i[this.nodeIdField] === node[this.nodeIdField]);
          if (itemIndex !== -1) {
            this.parentNode[this.childArrayName].splice(itemIndex, 1);
          }
        }else{
          this.$emit('remove-node', this.node);
        }
    }
  }
};
</script>

<style scoped lang="scss">
.no-bullets {
    list-style-type: none;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
}

.no-bullets > .d-flex {
    min-width: 0;
    max-width: 100%;
}

.no-bullets > .d-flex > span {
    min-width: 0;
}

:deep(.tree-children ) {
  padding-left: 2em;
}

.node-text {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 3px;
  padding-right: auto;
  //display: flex !important;
}

.node-content {
  display: flex;
  justify-content: space-between;
  align-items: center;  
}

.trash {
  cursor: pointer;
  position: relative;
}
.icon-stack {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 1.5em;  
  height: 1em; 
  vertical-align: middle;
  font-size: 0.9em;
  line-height: 1;
  margin-right: 2px;
}
.icon-folder{
  color: orange;
}
.icon-stack-2x,
.icon-stack-3x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: right;
}
.icon-stack-2x {
  font-size: 1.1em;
}
.icon-stack-3x {
  font-size: 1.3em;
}
.caret-icon{
  font-size: 1.3em;
  margin-top: 3px;
}
/* Same half-swept rule as ProductDraggableSearch's .selected: the darkening veil was
   invisible on dark, leaving selection with no cue. The 12% lift is the cue.

   Two corrections to an earlier version of this comment, which claimed more than was true:
   the border-color paints nothing (this is a <span class="node-text"> with no
   border-style, so the declaration is inert in both themes), and the "hovered rows lift by
   8%" it cited belongs to p-tree's .tree-row, which this component never renders. Light
   mode unchanged: both fallbacks are the original literals. */
:deep(.item-selected ) {
  background: var(--m-state-emphasis, rgba(0, 0, 0, 0.12)) !important;
  border-color: var(--m-accent, #ddd) !important;
}
</style>